import { Component, Input } from "@angular/core";

@Component({
	selector: "app-expander",
	templateUrl: "./expander.component.html",
	styleUrls: ["./expander.component.scss"]
})
export class ExpanderComponent {
	@Input()
	caption: string;

	public expanded = false;

	public Close() {
		this.expanded = false;
	}

}
